import _ from 'lodash';
import { AnyAction } from 'redux';
import { entityCollectionDefaultState, EntityCollectionState } from 'src/store/entities/types/EntityCollectionState';
import { FAILURE_CUSTOMER_DOCUMENTS, REQUEST_CUSTOMER_DOCUMENTS, SUCCESS_CUSTOMER_DOCUMENTS } from './actions';

/* Customer Documents */
export function customerDocumentsReducer(
    state: EntityCollectionState<any> = entityCollectionDefaultState(),
    action: AnyAction
) {
    switch (action.type) {
        case REQUEST_CUSTOMER_DOCUMENTS:
            return _.assign({}, state, { isFetching: true, error: undefined });
        case SUCCESS_CUSTOMER_DOCUMENTS: {
            return _.assign({}, state, {
                isFetching: false,
                items: action.response.data,
                error: undefined,
            });
        }
        case FAILURE_CUSTOMER_DOCUMENTS:
            return _.assign({}, state, { isFetching: false, items: undefined, error: action.error });
        default:
            return state;
    }
}
